import _ from '@/underscore'
import { settings } from '@/pe/portal/settings'
import { manifestManager } from '@/io.ox/core/manifests'

// this util class was introduced to avoid using portal/widgets.js
// because this would load *all* portal plugins

export const getWidgets = function () {
  return _(settings.get('widgets/user', {})).map(function (obj) {
    // make sure we always have props
    obj.props = obj.props || {}
    return obj
  })
}

export const getWidgetsByType = function (type) {
  return _(getWidgets()).filter(function (obj) {
    return obj.type === type
  })
}

// Filter to only user widgets
function filterUserWidgets (widgets) {
  const userWidgets = {}
  Object.keys(widgets).forEach(id => {
    if (widgets[id].userWidget) userWidgets[id] = widgets[id]
  })
  return userWidgets
}

// Upgrade or downgrade widgets from previous/later versions
export async function migrateWidgetPluginPaths (widgets) {
  let needsSave = false
  for (const widget in widgets) {
    const { plugin } = widgets[widget]
    if (!plugin || manifestManager.plugins[plugin]) continue
    if (manifestManager.plugins[plugin.replace('plugins/portal/', 'pe/portal/plugins/')]) {
      widgets[widget].plugin = plugin.replace('plugins/portal/', 'pe/portal/plugins/')
      needsSave = true
    } else if (manifestManager.plugins[plugin.replace('pe/portal/plugins/', 'plugins/portal/')]) {
      widgets[widget].plugin = plugin.replace('pe/portal/plugins/', 'plugins/portal/')
      needsSave = true
    } else if (!manifestManager.plugins[plugin]) {
      console.warn(`Plugin '${plugin}' not found for widget with id '${widget}'.`)
    }
  }
  if (needsSave) {
    await settings.set('widgets/user', filterUserWidgets(widgets)).save()
  }
}

// Repair wrongly migrated widgets (remove eager/protected from widgets/user)
export async function repairUserWidgets (widgets) {
  const userWidgets = filterUserWidgets(widgets)
  const needsRepair = Object.keys(userWidgets).length !== Object.keys(widgets).length

  if (needsRepair) {
    await settings.set('widgets/user', userWidgets).save()
  }
}
